<template>
  <a-modal
    :title="title"
    centered
    :width="500"
    :mask-closable="false"
    :visible="showRemarkForm"
    :confirmLoading="loading"
    @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      >
        <a-spin :spinning="loading">
          <template>
            <a-form-model-item label="备注" prop="remark" help="更新本系统备注，巨量没有提供接口，所以不能同步更新到巨量">
              <a-input v-model="model.remark" style="width:300px"/>
            </a-form-model-item>
          </template>

        </a-spin>
      </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Remark';
</style>

<script>
import Remark from './Remark'
export default Remark
</script>
